import React, { useEffect, useState } from 'react';
import DemoBanner from './_116_demo_banner';
import TrialExpiringBanner from './_89_trial_expiring_banner';
import AdminBanner from './_118_admin_banner';
const MODULE_NAME = "_117_banner_group";

/**
 * BannerGroup decides which banner to show based on account_type.
 * Respects user dismiss preference using sessionStorage during the session.
 * Supported banners: Demo, Trial, Admin
 */
function BannerGroup() {
    const [accountType, setAccountType] = useState("");
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/user-banner`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setAccountType(data.account_type || "");
                setUserId(data.user_id || null);
            })
            .catch((err) => {
                console.error("BannerGroup fetch error:", err);
                setAccountType("");
                setUserId(null);
            })
            .finally(() => setLoading(false));
    }, []);

    // Get dismissed banners from sessionStorage
    const dismissedBanners = JSON.parse(sessionStorage.getItem("dismissedBanners") || "{}");
    const isDemoDismissed = dismissedBanners.demo === true;
    const isTrialDismissed = dismissedBanners.trial === true;

    if (loading) return null;

    // Admin banner is shown for admin account_type, regardless of demo/trial banners
    if (accountType === "admin") {
        return <AdminBanner />;
    }
    if (accountType === "demo" && !isDemoDismissed) {
        return <DemoBanner />;
    }
    if (accountType === "trial" && !isTrialDismissed) {
        return <TrialExpiringBanner />;
    }
    // Add more banners here as needed

    return null;
}

export default BannerGroup;